import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/uptime/view/responseTimes/uptime.view.responseTimes.query.gql"
import type {
  UptimeViewResponseTimesQuery,
  UptimeViewResponseTimesQueryVariables,
} from "@/v2-backoffice-client/uptime/view/responseTimes/__types__/uptime.view.responseTimes.query"

type Options = QueryHookOptions<
  UptimeViewResponseTimesQuery,
  UptimeViewResponseTimesQueryVariables
>

export function useUptimeViewResponseTimesQuery(options?: Options) {
  return useQuery<
    UptimeViewResponseTimesQuery,
    UptimeViewResponseTimesQueryVariables
  >(query, options)
}
